import { IOnInit } from "angular";
import { IFieldArray } from "AngularFormly";

const template = require("!html-loader!./index.html").default;
export class DepreciationDefaultSettingViewController implements IOnInit {
  static $inject = ["model"];

  formFields!: IFieldArray;
  defaultSettings: any;

  constructor(public readonly model: any) {}

  $onInit(): void {
    this.defaultSettings = this.model;
  }
  getDepreciationMethod(method: string) {
    switch (method) {
      case "StraightLine":
        return "Straight Line";
      case "DoubleDecliningBalance":
        return "Double Declining Balance";
      case "SumOfTheYearsDigits":
        return "Sum Of The Years Digits";
      default:
        return "";
    }
  }
}
